<template>
  <ModalView
    v-model="show"
    title="Change Display Name"
    @ok="confirm"
    ok-title="Save"
    :busy="saving"
    :disable-ok="!canSubmit"
  >
    <form @submit.prevent="confirm" class="d-flex flex-column gap-3">
      <div>
        <label class="form-label">Display Name</label>
        <input ref="displayName" type="text" v-model.trim="displayName" class="form-control" />
      </div>
    </form>
  </ModalView>
</template>

<script>
import {Session} from "@/models/User";
import ModalView from "@/components/common/ModalView.vue";

export default {
  components: {ModalView},
  props: {
    modelValue: Boolean
  },
  emits: ['update:modelValue'],
  data() {
    return {
      displayName: '',
      saving: false
    };
  },
  computed: {
    show: {
      get() {
        return this.modelValue;
      },
      set(v) {
        this.displayName = Session.currentUser.value.displayName;
        this.$emit('update:modelValue', v);
        if (v) {
          this.$nextTick(() => this.$refs.displayName.focus());
        }
      }
    },
    canSubmit() {
      return Boolean(this.displayName.trim());
    }
  },
  methods: {
    async confirm() {
      this.saving = true;
      try {
        await Session.currentUser.value.updateUser({displayName:this.displayName});
        this.show = false;
      } finally {
        this.saving = false;
      }
    }
  }
}
</script>
